import styled from 'styled-components'

export default styled.div`
  margin-right: 10px;
`
